module.exports = __webpack_public_path__ + "static/media/a-112-plan.bdce69a3.webp";